"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ValuationToDataTransformer = void 0;
const Valuation_1 = require("../Model/Valuation");
const Collection_1 = require("../Model/Collection");
/**
 * Transforms the inputs of the form into a customer object.
 */
class ValuationToDataTransformer {
    constructor(customerTransformer, vehicleTransformer, answeredQuestionsTransformer, dealerTransformer, priceExtractor, valuationDataToDataTransformer) {
        this.customerTransformer = customerTransformer;
        this.vehicleTransformer = vehicleTransformer;
        this.answeredQuestionsTransformer = answeredQuestionsTransformer;
        this.dealerTransformer = dealerTransformer;
        this.priceExtractor = priceExtractor;
        this.valuationDataTransformer = valuationDataToDataTransformer;
    }
    /**
     * @inheritDoc
     */
    to(valuation) {
        const data = {
            vrm: valuation.getVrm(),
        };
        if (valuation.getCustomer().getId()) {
            data.customer = valuation.getCustomer().getId();
        }
        if (valuation.getVehicle().getId()) {
            data.vehicle = valuation.getVehicle().getId();
        }
        if (valuation.getPreferredDealer().getId()) {
            data.preferredDealer = valuation.getPreferredDealer().getId();
        }
        data.source = { name: valuation.getSource(), url: valuation.getSourceUrl() };
        const setters = {
            equity: valuation.getEquity,
            completed: valuation.isCompleted,
            status: valuation.getStatus,
            context: valuation.getContext,
            returnLink: valuation.getReturnLink
        };
        Object.entries(setters).forEach(([prop, setter]) => {
            this.setIfNotUndefined(data, prop, valuation, setter);
        });
        return data;
    }
    /**
     * @inheritDoc
     */
    from(data) {
        const valuation = new Valuation_1.default()
            .setToken(data.token)
            .setMileage(data.mileage)
            .setVrm(data.vrm)
            .setStatus(data.status)
            .setEquity(data.equity)
            .setSource(data.sourceName)
            .setSourceUrl(data.sourceUrl)
            .setContext(data.context)
            .setReturnLink(data.returnLink)
            .setCompleted(data.completed);
        if (data.valuation) {
            let valuationData = this.valuationDataTransformer.from(data.valuation);
            valuation.setValuationData(valuationData)
                .setOutstandingFinance(valuationData.getOutstandingFinanceValue())
                .setCreatedAt(valuationData.getCreatedAt())
                .setUpdatedAt(valuationData.getUpdatedAt())
                .setExpiredAt(valuationData.getExpiresAt());
        }
        if (data.answeredQuestionnaire.items) {
            valuation.setAnsweredQuestionnaires(new Collection_1.default(data.answeredQuestionnaire.items.map((v) => this.answeredQuestionsTransformer.from(v))));
        }
        if (data.vehicle) {
            valuation.setVehicle(this.vehicleTransformer.from(data.vehicle));
        }
        if (data.customer) {
            valuation.setCustomer(this.customerTransformer.from(data.customer));
        }
        if (data.preferredDealer) {
            valuation.getPreferredDealer().setId(data.preferredDealer);
        }
        valuation.setActualPrice(this.priceExtractor.getActualPrice(valuation));
        return valuation;
    }
    setIfNotUndefined(data, prop, vehicle, getter) {
        if (getter.call(vehicle)) {
            data[prop] = getter.call(vehicle);
        }
    }
}
exports.ValuationToDataTransformer = ValuationToDataTransformer;
